export default __webpack_public_path__ + "media/zurb/img/services/process/leap-img-20043d30a43b77fe2209b212cf8c8a60.png";